import { render, staticRenderFns } from "./FriendsModal.vue?vue&type=template&id=01cc5cae&"
import script from "./FriendsModal.vue?vue&type=script&lang=js&"
export * from "./FriendsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports